// Mock data for demo mode
import type { Filament, Spool, Printer, Project, MaintenanceLog, Print, PrinterTemplate, FilamentBrand, FilamentProduct, FilamentSubmission, MaterialPreset, PrinterManufacturer, PrinterModel } from '@/types'

const STORAGE_PREFIX = 'printhq_demo_'

// Helper to generate IDs
const generateId = () => `demo-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

// ============================================
// MOCK FILAMENTS
// ============================================
export const MOCK_FILAMENTS: Filament[] = [
  {
    id: 'fil-1',
    user_id: 'demo-user-123',
    name: 'Jet Black PLA',
    brand: 'Prusament',
    material: 'PLA',
    color: 'Black',
    color_hex: '#1a1a1a',
    colors: ['#1a1a1a'],
    filament_code: 'phq_filament_a1b2c3d4e5',
    diameter: 1.75,
    weight_total: 1000,
    weight_remaining: 750,
    spool_weight: 200,
    cost: 29.99,
    purchase_date: '2024-01-01',
    print_temp_min: 200,
    print_temp_max: 220,
    bed_temp_min: 50,
    bed_temp_max: 60,
    is_active: true,
    low_stock_threshold: 5000,
    manufacturer_url: 'https://www.prusa3d.com/product/prusament-pla-jet-black-1kg/',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'fil-2',
    user_id: 'demo-user-123',
    name: 'Signal White PLA',
    brand: 'Prusament',
    material: 'PLA',
    color: 'White',
    color_hex: '#ffffff',
    colors: ['#ffffff'],
    filament_code: 'phq_filament_f6g7h8i9j0',
    diameter: 1.75,
    weight_total: 1000,
    weight_remaining: 420,
    spool_weight: 200,
    cost: 29.99,
    purchase_date: '2024-01-05',
    print_temp_min: 200,
    print_temp_max: 220,
    bed_temp_min: 50,
    bed_temp_max: 60,
    is_active: true,
    low_stock_threshold: 5000,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'fil-3',
    user_id: 'demo-user-123',
    name: 'Orange PETG',
    brand: 'Overture',
    material: 'PETG',
    color: 'Orange',
    color_hex: '#ff6b00',
    colors: ['#ff6b00'],
    filament_code: 'phq_filament_k1l2m3n4o5',
    diameter: 1.75,
    weight_total: 1000,
    weight_remaining: 890,
    spool_weight: 250,
    cost: 22.99,
    purchase_date: '2024-01-10',
    print_temp_min: 230,
    print_temp_max: 250,
    bed_temp_min: 70,
    bed_temp_max: 85,
    is_active: true,
    manufacturer_url: 'https://overture3d.com/products/overture-petg-filament',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'fil-4',
    user_id: 'demo-user-123',
    name: 'Blue TPU 95A',
    brand: 'SainSmart',
    material: 'TPU',
    color: 'Blue & White',
    color_hex: '#2563eb',
    colors: ['#2563eb', '#ffffff'],
    filament_code: 'phq_filament_p6q7r8s9t0',
    diameter: 1.75,
    weight_total: 800,
    weight_remaining: 65,
    spool_weight: 200,
    cost: 35.99,
    purchase_date: '2023-12-15',
    print_temp_min: 210,
    print_temp_max: 230,
    bed_temp_min: 40,
    bed_temp_max: 60,
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'fil-5',
    user_id: 'demo-user-123',
    name: 'Galaxy Silver PLA',
    brand: 'Hatchbox',
    material: 'PLA',
    color: 'Silver',
    color_hex: '#a8a8a8',
    colors: ['#a8a8a8'],
    filament_code: 'phq_filament_u1v2w3x4y5',
    diameter: 1.75,
    weight_total: 1000,
    weight_remaining: 1000,
    spool_weight: 200,
    cost: 24.99,
    purchase_date: '2024-01-20',
    print_temp_min: 195,
    print_temp_max: 215,
    bed_temp_min: 45,
    bed_temp_max: 60,
    is_active: true,
    manufacturer_url: 'https://www.hatchbox3d.com/collections/pla',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// MOCK SPOOLS
// ============================================
export const MOCK_SPOOLS: Spool[] = [
  {
    id: 'spool-1',
    user_id: 'demo-user-123',
    filament_id: 'fil-1',
    spool_code: 'phq_spool_a1b2c3d4e5',
    label: 'Spool 1',
    weight_total: 1000,
    weight_remaining: 750,
    spool_weight: 200,
    cost: 29.99,
    purchase_date: '2024-01-01',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'spool-2',
    user_id: 'demo-user-123',
    filament_id: 'fil-2',
    spool_code: 'phq_spool_f6g7h8i9j0',
    label: 'Spool 1',
    weight_total: 1000,
    weight_remaining: 420,
    spool_weight: 200,
    cost: 29.99,
    purchase_date: '2024-01-05',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'spool-3',
    user_id: 'demo-user-123',
    filament_id: 'fil-3',
    spool_code: 'phq_spool_k1l2m3n4o5',
    label: 'Spool 1',
    weight_total: 1000,
    weight_remaining: 890,
    spool_weight: 250,
    cost: 22.99,
    purchase_date: '2024-01-10',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'spool-4',
    user_id: 'demo-user-123',
    filament_id: 'fil-4',
    spool_code: 'phq_spool_p6q7r8s9t0',
    label: 'Spool 1',
    weight_total: 800,
    weight_remaining: 65,
    spool_weight: 200,
    cost: 35.99,
    purchase_date: '2023-12-15',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'spool-5',
    user_id: 'demo-user-123',
    filament_id: 'fil-5',
    spool_code: 'phq_spool_u1v2w3x4y5',
    label: 'Spool 1',
    weight_total: 1000,
    weight_remaining: 1000,
    spool_weight: 200,
    cost: 24.99,
    purchase_date: '2024-01-20',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'spool-6',
    user_id: 'demo-user-123',
    filament_id: 'fil-1',
    spool_code: 'phq_spool_z6a7b8c9d0',
    label: 'Spool 2',
    weight_total: 1000,
    weight_remaining: 1000,
    spool_weight: 200,
    cost: 29.99,
    purchase_date: '2024-02-01',
    is_active: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// MOCK PRINTERS
// ============================================
export const MOCK_PRINTERS: Printer[] = [
  {
    id: 'prt-1',
    user_id: 'demo-user-123',
    name: 'Prusa MK3S+',
    emoji: '🦾',
    printer_code: 'phq_printer_abc1234567',
    manufacturer: 'Prusa Research',
    model: 'MK3S+',
    type: 'FDM',
    status: 'idle',
    build_volume_x: 250,
    build_volume_y: 210,
    build_volume_z: 210,
    nozzle_diameter: 0.4,
    max_print_temp: 300,
    max_bed_temp: 120,
    has_heated_bed: true,
    has_enclosure: false,
    purchase_date: '2023-06-15',
    firmware_version: '3.13.1',
    total_print_time: 4520,
    total_prints: 87,
    last_maintenance_date: '2024-01-10',
    maintenance_fee: 0.50,
    electricity_rate: 0.12,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'prt-2',
    user_id: 'demo-user-123',
    name: 'Ender 3 V2',
    emoji: '⚡',
    printer_code: 'phq_printer_def9876543',
    manufacturer: 'Creality',
    model: 'Ender 3 V2',
    type: 'FDM',
    status: 'printing',
    build_volume_x: 220,
    build_volume_y: 220,
    build_volume_z: 250,
    nozzle_diameter: 0.4,
    max_print_temp: 260,
    max_bed_temp: 100,
    has_heated_bed: true,
    has_enclosure: true,
    purchase_date: '2022-11-20',
    firmware_version: 'Marlin 2.1.2',
    total_print_time: 8930,
    total_prints: 156,
    last_maintenance_date: '2024-01-05',
    maintenance_fee: 0.35,
    electricity_rate: 0.12,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'prt-3',
    user_id: 'demo-user-123',
    name: 'Bambu Lab P1S',
    emoji: '🚀',
    printer_code: 'phq_printer_ghi5551234',
    manufacturer: 'Bambu Lab',
    model: 'P1S',
    type: 'FDM',
    status: 'idle',
    build_volume_x: 256,
    build_volume_y: 256,
    build_volume_z: 256,
    nozzle_diameter: 0.4,
    max_print_temp: 300,
    max_bed_temp: 110,
    has_heated_bed: true,
    has_enclosure: true,
    purchase_date: '2024-01-01',
    firmware_version: '01.06.00.00',
    total_print_time: 320,
    total_prints: 12,
    maintenance_fee: 0.75,
    electricity_rate: 0.12,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// MOCK PRINTS
// ============================================
export const MOCK_PRINTS: Print[] = [
  {
    id: 'pnt-1',
    user_id: 'demo-user-123',
    printer_id: 'prt-1',
    project_id: 'prj-1',
    name: 'Phone Stand v2',
    file_name: 'phone_stand_v2.gcode',
    status: 'completed',
    quality: 'high',
    layer_height: 0.15,
    infill_percentage: 20,
    supports_enabled: false,
    estimated_time: 165,
    actual_time: 172,
    estimated_filament: 45,
    actual_filament: 48,
    start_time: '2024-01-15T08:00:00Z',
    end_time: '2024-01-15T10:52:00Z',
    rating: 5,
    notes: 'Clean print, no issues',
    quantity: 1,
    progress: 100,
    current_layer: 200,
    total_layers: 200,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'pnt-2',
    user_id: 'demo-user-123',
    printer_id: 'prt-2',
    project_id: 'prj-1',
    name: 'Cable Organizer',
    file_name: 'cable_organizer.gcode',
    status: 'printing',
    quality: 'normal',
    layer_height: 0.2,
    infill_percentage: 15,
    supports_enabled: false,
    estimated_time: 80,
    estimated_filament: 32,
    start_time: '2024-01-15T14:00:00Z',
    quantity: 3,
    progress: 45,
    current_layer: 90,
    total_layers: 200,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'pnt-3',
    user_id: 'demo-user-123',
    printer_id: 'prt-1',
    project_id: 'prj-1',
    name: 'Desk Hook',
    file_name: 'desk_hook.gcode',
    status: 'failed',
    quality: 'normal',
    layer_height: 0.2,
    infill_percentage: 30,
    supports_enabled: true,
    estimated_time: 45,
    actual_time: 22,
    estimated_filament: 18,
    actual_filament: 10,
    start_time: '2024-01-15T06:00:00Z',
    end_time: '2024-01-15T06:22:00Z',
    failure_reason: 'Bed adhesion failure',
    quantity: 1,
    progress: 0,
    current_layer: 0,
    total_layers: 112,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// MOCK FILAMENT USAGE (seed data for cost calculations)
// ============================================
export const MOCK_FILAMENT_USAGE = [
  {
    id: 'fu-1',
    user_id: 'demo-user-123',
    filament_id: 'fil-1',
    spool_id: 'spool-1',
    print_id: 'pnt-1',
    amount_used: 48,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'fu-2',
    user_id: 'demo-user-123',
    filament_id: 'fil-2',
    spool_id: 'spool-2',
    print_id: 'pnt-2',
    amount_used: 32,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'fu-3',
    user_id: 'demo-user-123',
    filament_id: 'fil-1',
    spool_id: 'spool-1',
    print_id: 'pnt-3',
    amount_used: 10,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
]

// ============================================
// MOCK PROJECTS
// ============================================
export const MOCK_PROJECTS: Project[] = [
  {
    id: 'prj-1',
    user_id: 'demo-user-123',
    name: 'Desk Organizer Set',
    description: 'A complete set of desk accessories including pen holders, cable management, and phone stand.',
    status: 'in_progress',
    start_date: '2024-01-10',
    tags: ['desk', 'organization', 'functional'],
    total_prints: 8,
    successful_prints: 7,
    failed_prints: 1,
    total_filament_used: 340,
    total_print_time: 1280,
    estimated_cost: 15.50,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'prj-2',
    user_id: 'demo-user-123',
    name: 'Raspberry Pi 5 Case',
    description: 'Custom enclosure for Raspberry Pi 5 with active cooling and GPIO access.',
    status: 'completed',
    start_date: '2024-01-01',
    completed_date: '2024-01-08',
    tags: ['electronics', 'enclosure', 'raspberry-pi'],
    total_prints: 4,
    successful_prints: 4,
    failed_prints: 0,
    total_filament_used: 85,
    total_print_time: 420,
    estimated_cost: 4.20,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'prj-3',
    user_id: 'demo-user-123',
    name: 'Garden Tool Hooks',
    description: 'Wall-mounted hooks for organizing garden tools in the shed.',
    status: 'planning',
    tags: ['outdoor', 'organization', 'hooks'],
    total_prints: 0,
    successful_prints: 0,
    failed_prints: 0,
    total_filament_used: 0,
    total_print_time: 0,
    estimated_cost: 0,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// MOCK MAINTENANCE LOGS
// ============================================
export const MOCK_MAINTENANCE: MaintenanceLog[] = [
  {
    id: 'mnt-1',
    user_id: 'demo-user-123',
    printer_id: 'prt-1',
    type: 'nozzle_clean',
    title: 'Monthly nozzle cleaning',
    description: 'Perform cold pull and clean nozzle exterior',
    priority: 'medium',
    is_completed: false,
    scheduled_date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days from now
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'mnt-2',
    user_id: 'demo-user-123',
    printer_id: 'prt-2',
    type: 'belt_tension',
    title: 'Check belt tension',
    description: 'X and Y axis belts need tension check - noticed some layer shifting',
    priority: 'high',
    is_completed: false,
    scheduled_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), // 1 day ago (overdue)
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'mnt-3',
    user_id: 'demo-user-123',
    printer_id: 'prt-1',
    type: 'lubrication',
    title: 'Lubricate linear rails',
    description: 'Applied fresh lubricant to all linear rails and bearings',
    priority: 'low',
    is_completed: true,
    completed_date: '2024-01-10',
    scheduled_date: '2024-01-10',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// ============================================
// LOCAL STORAGE HELPERS
// ============================================

export function loadFromStorage<T>(key: string, defaultData: T[]): T[] {
  try {
    const stored = localStorage.getItem(STORAGE_PREFIX + key)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (e) {
    console.error('Error loading from storage:', e)
  }
  // Initialize with default data
  saveToStorage(key, defaultData)
  return defaultData
}

export function saveToStorage<T>(key: string, data: T[]): void {
  try {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(data))
  } catch (e) {
    console.error('Error saving to storage:', e)
  }
}

// ============================================
// MOCK CRUD OPERATIONS
// ============================================

export const mockCrud = {
  // Generic fetch
  fetch<T>(key: string, defaultData: T[]): T[] {
    return loadFromStorage(key, defaultData)
  },

  // Generic create
  create<T extends { id?: string }>(key: string, item: T, existingData: T[]): T {
    const newItem = { ...item, id: generateId() } as T
    const updated = [newItem, ...existingData]
    saveToStorage(key, updated)
    return newItem
  },

  // Generic update
  update<T extends { id: string }>(key: string, id: string, updates: Partial<T>, existingData: T[]): T | null {
    const index = existingData.findIndex((item: any) => item.id === id)
    if (index === -1) return null
    
    const updatedItem = { ...existingData[index], ...updates, updated_at: new Date().toISOString() }
    existingData[index] = updatedItem
    saveToStorage(key, existingData)
    return updatedItem as T
  },

  // Generic delete
  delete<T extends { id: string }>(key: string, id: string, existingData: T[]): boolean {
    const filtered = existingData.filter((item: any) => item.id !== id)
    if (filtered.length === existingData.length) return false
    saveToStorage(key, filtered)
    return true
  }
}

// ============================================
// MOCK PRINTER TEMPLATES (Admin)
// ============================================
export const MOCK_PRINTER_TEMPLATES: PrinterTemplate[] = [
  {
    id: 'tpl-1', name: 'Prusa MK4', manufacturer: 'Prusa Research', model: 'MK4',
    type: 'FDM', build_volume_x: 250, build_volume_y: 210, build_volume_z: 220,
    nozzle_diameter: 0.4, max_print_temp: 300, max_bed_temp: 120,
    has_heated_bed: true, has_enclosure: false, image_url: null, notes: null,
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 'tpl-2', name: 'Bambu Lab P1S', manufacturer: 'Bambu Lab', model: 'P1S',
    type: 'FDM', build_volume_x: 256, build_volume_y: 256, build_volume_z: 256,
    nozzle_diameter: 0.4, max_print_temp: 300, max_bed_temp: 110,
    has_heated_bed: true, has_enclosure: true, image_url: null, notes: null,
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 'tpl-3', name: 'Bambu Lab X1 Carbon', manufacturer: 'Bambu Lab', model: 'X1C',
    type: 'FDM', build_volume_x: 256, build_volume_y: 256, build_volume_z: 256,
    nozzle_diameter: 0.4, max_print_temp: 300, max_bed_temp: 110,
    has_heated_bed: true, has_enclosure: true, image_url: null, notes: 'Multi-material support with AMS',
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 'tpl-4', name: 'Creality Ender 3 V3', manufacturer: 'Creality', model: 'Ender 3 V3',
    type: 'FDM', build_volume_x: 220, build_volume_y: 220, build_volume_z: 250,
    nozzle_diameter: 0.4, max_print_temp: 300, max_bed_temp: 110,
    has_heated_bed: true, has_enclosure: false, image_url: null, notes: null,
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 'tpl-5', name: 'Voron 2.4', manufacturer: 'Voron Design', model: '2.4 R2',
    type: 'FDM', build_volume_x: 350, build_volume_y: 350, build_volume_z: 350,
    nozzle_diameter: 0.4, max_print_temp: 300, max_bed_temp: 120,
    has_heated_bed: true, has_enclosure: true, image_url: null, notes: 'CoreXY kit printer',
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 'tpl-6', name: 'Prusa Mini+', manufacturer: 'Prusa Research', model: 'Mini+',
    type: 'FDM', build_volume_x: 180, build_volume_y: 180, build_volume_z: 180,
    nozzle_diameter: 0.4, max_print_temp: 280, max_bed_temp: 100,
    has_heated_bed: true, has_enclosure: false, image_url: null, notes: null,
    created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z'
  }
]

// ============================================
// MOCK PRINTER MANUFACTURERS (Admin)
// ============================================
export const MOCK_PRINTER_MANUFACTURERS: PrinterManufacturer[] = [
  { id: 'mfg-1', name: 'Prusa Research', logo_url: null, website: 'https://prusa3d.com', country: 'Czech Republic', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-2', name: 'Bambu Lab', logo_url: null, website: 'https://bambulab.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-3', name: 'Creality', logo_url: null, website: 'https://creality.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-4', name: 'Voron Design', logo_url: null, website: 'https://vorondesign.com', country: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-5', name: 'Anycubic', logo_url: null, website: 'https://anycubic.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-6', name: 'Elegoo', logo_url: null, website: 'https://elegoo.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-7', name: 'FlashForge', logo_url: null, website: 'https://flashforge.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-8', name: 'Ultimaker', logo_url: null, website: 'https://ultimaker.com', country: 'Netherlands', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-9', name: 'LulzBot', logo_url: null, website: 'https://lulzbot.com', country: 'United States', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-10', name: 'Raise3D', logo_url: null, website: 'https://raise3d.com', country: 'China', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-11', name: 'Formlabs', logo_url: null, website: 'https://formlabs.com', country: 'United States', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mfg-12', name: 'Markforged', logo_url: null, website: 'https://markforged.com', country: 'United States', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
]

// ============================================
// MOCK PRINTER MODELS (Admin)
// ============================================
const ts = '2024-01-01T00:00:00Z'
const model = (id: string, name: string, mfgId: string, mfgName: string, bridge: boolean, caps: [boolean, boolean, boolean, boolean] = [false, false, false, false], multicolor = false, defaultMaterialSystem?: PrinterModel['default_material_system'], excludeObjects = false): PrinterModel => ({
  id, name, manufacturer_id: mfgId, manufacturer_name: mfgName, bridge_supported: bridge,
  can_print: caps[0], can_control: caps[1], can_telemetry: caps[2], can_camera: caps[3],
  supports_multicolor: multicolor,
  supports_exclude_objects: excludeObjects,
  default_material_system: defaultMaterialSystem ?? null,
  created_at: ts, updated_at: ts,
})

export const MOCK_PRINTER_MODELS: PrinterModel[] = [
  // Bambu Lab (mfg-2) — all fully supported, all multi-color (AMS)
  model('mdl-1', 'A1', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  model('mdl-2', 'A1 Mini', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  model('mdl-3', 'P1S', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  model('mdl-4', 'P1P', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  model('mdl-5', 'X1 Carbon', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  model('mdl-6', 'X1E', 'mfg-2', 'Bambu Lab', true, [true, true, true, true], true),
  // Elegoo (mfg-6) — supported
  model('mdl-10', 'Centauri Carbon', 'mfg-6', 'Elegoo', true, [true, true, true, true], false),
  model('mdl-11', 'Neptune 4 Pro', 'mfg-6', 'Elegoo', true, [true, true, true, true]),
  model('mdl-12', 'Saturn 4 Ultra', 'mfg-6', 'Elegoo', true, [true, true, true, false]),
  // Prusa (mfg-1) — not yet supported
  model('mdl-20', 'MK3S+', 'mfg-1', 'Prusa Research', false, [false, false, false, false], true),
  model('mdl-21', 'MK4', 'mfg-1', 'Prusa Research', false, [false, false, false, false], true),
  model('mdl-22', 'XL', 'mfg-1', 'Prusa Research', false, [false, false, false, false], true),
  model('mdl-23', 'Mini+', 'mfg-1', 'Prusa Research', false),
  // Creality (mfg-3) — partial support
  model('mdl-30', 'Ender 3 V3 KE', 'mfg-3', 'Creality', true, [true, true, true, false]),
  model('mdl-31', 'K1 Max', 'mfg-3', 'Creality', true, [true, true, true, true]),
  model('mdl-32', 'Ender 3 V2', 'mfg-3', 'Creality', false),
  // FlashForge (mfg-7)
  model('mdl-40', 'Adventurer 5M', 'mfg-7', 'FlashForge', true, [true, true, true, false]),
  model('mdl-41', 'Adventurer 5M Pro', 'mfg-7', 'FlashForge', true, [true, true, true, false]),
  model('mdl-42', 'Adventurer 5X', 'mfg-7', 'FlashForge', true, [true, true, true, true], true, {
    units: [{
      type: 'preset',
      unit_id: 'mock-ifs',
      label: 'FlashForge IFS',
      slot_count: 4,
      quantity: 1,
      slot_label_prefix: 'S',
      slot_label_style: 'numeric',
    }],
    slot_count: 4,
  }),
]

// ============================================
// MOCK FILAMENT BRANDS (Admin)
// ============================================
export const MOCK_FILAMENT_BRANDS: FilamentBrand[] = [
  { id: 'brand-1', name: 'Prusament', logo_url: null, website: 'https://prusament.com', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'brand-2', name: 'Hatchbox', logo_url: null, website: 'https://www.hatchbox3d.com', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'brand-3', name: 'Polymaker', logo_url: null, website: 'https://polymaker.com', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'brand-4', name: 'eSUN', logo_url: null, website: 'https://www.esun3d.com', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'brand-5', name: 'Overture', logo_url: null, website: 'https://overture3d.com', created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
]

// ============================================
// MOCK FILAMENT PRODUCTS (Admin)
// ============================================
export const MOCK_FILAMENT_PRODUCTS: FilamentProduct[] = [
  { id: 'fp-1', brand_id: 'brand-1', name: 'Prusament PLA Galaxy Black', material: 'PLA', color: 'Galaxy Black', color_hex: '#1a1a2e', diameter: 1.75, print_temp_min: 200, print_temp_max: 220, bed_temp_min: 50, bed_temp_max: 60, weight_per_spool: 1000, msrp: 29.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-2', brand_id: 'brand-1', name: 'Prusament PETG Orange', material: 'PETG', color: 'Orange', color_hex: '#ff6600', diameter: 1.75, print_temp_min: 230, print_temp_max: 250, bed_temp_min: 80, bed_temp_max: 90, weight_per_spool: 1000, msrp: 29.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-3', brand_id: 'brand-2', name: 'Hatchbox PLA White', material: 'PLA', color: 'White', color_hex: '#ffffff', diameter: 1.75, print_temp_min: 190, print_temp_max: 220, bed_temp_min: 45, bed_temp_max: 60, weight_per_spool: 1000, msrp: 23.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-4', brand_id: 'brand-2', name: 'Hatchbox ABS Black', material: 'ABS', color: 'Black', color_hex: '#000000', diameter: 1.75, print_temp_min: 220, print_temp_max: 250, bed_temp_min: 95, bed_temp_max: 110, weight_per_spool: 1000, msrp: 24.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-5', brand_id: 'brand-3', name: 'PolyLite PLA Pro Grey', material: 'PLA', color: 'Grey', color_hex: '#808080', diameter: 1.75, print_temp_min: 200, print_temp_max: 230, bed_temp_min: 50, bed_temp_max: 60, weight_per_spool: 1000, msrp: 25.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-6', brand_id: 'brand-3', name: 'PolyMax PETG Blue', material: 'PETG', color: 'Blue', color_hex: '#0066cc', diameter: 1.75, print_temp_min: 230, print_temp_max: 250, bed_temp_min: 75, bed_temp_max: 85, weight_per_spool: 1000, msrp: 32.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-7', brand_id: 'brand-4', name: 'eSUN PLA+ Red', material: 'PLA', color: 'Red', color_hex: '#cc0000', diameter: 1.75, print_temp_min: 205, print_temp_max: 225, bed_temp_min: 50, bed_temp_max: 60, weight_per_spool: 1000, msrp: 19.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'fp-8', brand_id: 'brand-5', name: 'Overture TPU Flexible Black', material: 'TPU', color: 'Black', color_hex: '#1a1a1a', diameter: 1.75, print_temp_min: 210, print_temp_max: 230, bed_temp_min: 40, bed_temp_max: 60, weight_per_spool: 1000, msrp: 21.99, product_url: null, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
]

// ============================================
// MOCK FILAMENT SUBMISSIONS
// ============================================
export const MOCK_FILAMENT_SUBMISSIONS: FilamentSubmission[] = [
  { id: 'sub-1', user_id: 'demo-user-123', brand_name: 'Bambu Lab', name: 'Bambu PLA Basic Matte Black', material: 'PLA', color: 'Matte Black', color_hex: '#2d2d2d', colors: ['#2d2d2d'], diameter: 1.75, print_temp_min: 190, print_temp_max: 220, bed_temp_min: 50, bed_temp_max: 60, weight_per_spool: 1000, msrp: 17.99, product_url: 'https://bambulab.com', status: 'pending', created_at: '2024-02-01T00:00:00Z', updated_at: '2024-02-01T00:00:00Z' },
  { id: 'sub-2', user_id: 'demo-user-123', brand_name: 'Sunlu', name: 'Sunlu PETG Transparent Blue', material: 'PETG', color: 'Transparent Blue', color_hex: '#4488cc', colors: ['#4488cc'], diameter: 1.75, print_temp_min: 220, print_temp_max: 250, bed_temp_min: 70, bed_temp_max: 85, weight_per_spool: 1000, msrp: 18.99, status: 'approved', reviewed_at: '2024-02-05T00:00:00Z', created_at: '2024-02-01T00:00:00Z', updated_at: '2024-02-05T00:00:00Z' },
  { id: 'sub-3', user_id: 'demo-user-123', brand_name: 'Unknown Brand', name: 'Mystery Silk Gold PLA', material: 'PLA', color: 'Silk Gold', color_hex: '#d4a843', colors: ['#d4a843'], diameter: 1.75, print_temp_min: 195, print_temp_max: 215, bed_temp_min: 50, bed_temp_max: 60, weight_per_spool: 1000, status: 'rejected', admin_notes: 'Brand not identifiable — please provide more details about the manufacturer.', created_at: '2024-01-20T00:00:00Z', updated_at: '2024-01-25T00:00:00Z' },
]

// ============================================
// MOCK MATERIAL PRESETS
// ============================================
export const MOCK_MATERIAL_PRESETS: MaterialPreset[] = [
  { id: 'mp-1',  name: 'PLA',          description: 'Most popular, easy to print, biodegradable',      print_temp_min: 190, print_temp_max: 220, bed_temp_min:  50, bed_temp_max:  60, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-2',  name: 'PETG',         description: 'Strong, flexible, good chemical resistance',      print_temp_min: 220, print_temp_max: 250, bed_temp_min:  70, bed_temp_max:  85, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-3',  name: 'ABS',          description: 'Durable, heat resistant, requires enclosure',     print_temp_min: 230, print_temp_max: 260, bed_temp_min:  90, bed_temp_max: 110, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-4',  name: 'TPU',          description: 'Flexible, rubber-like, impact resistant',         print_temp_min: 210, print_temp_max: 230, bed_temp_min:  30, bed_temp_max:  60, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-5',  name: 'Nylon',        description: 'Very strong, wear resistant, absorbs moisture',   print_temp_min: 240, print_temp_max: 270, bed_temp_min:  70, bed_temp_max:  90, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-6',  name: 'ASA',          description: 'UV resistant, great for outdoor use',             print_temp_min: 235, print_temp_max: 255, bed_temp_min:  90, bed_temp_max: 110, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-7',  name: 'PC',           description: 'Extremely strong, high heat resistance',          print_temp_min: 260, print_temp_max: 300, bed_temp_min: 100, bed_temp_max: 120, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-8',  name: 'HIPS',         description: 'Lightweight, used as soluble support for ABS',    print_temp_min: 220, print_temp_max: 240, bed_temp_min:  90, bed_temp_max: 110, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-9',  name: 'PVA',          description: 'Water-soluble support material',                  print_temp_min: 180, print_temp_max: 200, bed_temp_min:  45, bed_temp_max:  60, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-10', name: 'Wood',         description: 'PLA-based with wood fibers, natural look',        print_temp_min: 180, print_temp_max: 220, bed_temp_min:  50, bed_temp_max:  60, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-11', name: 'Carbon Fiber', description: 'Reinforced composite, very stiff and strong',     print_temp_min: 200, print_temp_max: 230, bed_temp_min:  50, bed_temp_max:  70, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-12', name: 'Metal',        description: 'PLA-based with metal powder, can be polished',    print_temp_min: 190, print_temp_max: 220, bed_temp_min:  50, bed_temp_max:  60, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
  { id: 'mp-13', name: 'Other',        description: 'Custom or specialty material',                    print_temp_min: 200, print_temp_max: 230, bed_temp_min:  50, bed_temp_max:  70, created_at: '2024-01-01T00:00:00Z', updated_at: '2024-01-01T00:00:00Z' },
]
